import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            companies: [],
            userId: 0,
            currentDate: new Date(),
            currentWeek: '',
            week: [],

            showDatePicker: false,
            selectedDate: "",
            isLoading: true,
            showAddDefinition: false,
            showChooseDefinition: false,
            addDefinitionDate: '',
            definitionDataToEdit: null,
            chooseDefinitionDate: '',
            startDate: '',
            endDate: '',
            showWodResults: false,
            membershipExpired: false,
            hasProgramError: false,
            programErrorMessage: LocService.t('label_wod_program_display_error'),
        }
    },
    methods: {
        getMe: getMe,
        getStartOfWeek: getStartOfWeek,
        formatDate: formatDate,
        editDefinitionData: editDefinitionData,
        displayWeek: displayWeek,
        deleteTrainingOfTheDay: deleteTrainingOfTheDay,
        getTrainingOfTheDayForPeriod: getTrainingOfTheDayForPeriod,
        showDefinitionAdd: showDefinitionAdd,
        changeWeek: changeWeek,
        getDayFromDate: getDayFromDate,
        getPlaceholderTypeByMeasure: getPlaceholderTypeByMeasure,
        getName: getName,
        getShortDesc: getShortDesc,
        getLongDesc: getLongDesc,
        handleProgramDisplayError: handleProgramDisplayError,
        saveResults: saveResults,
        getTrainingResultsForTrainingOfTheDays: getTrainingResultsForTrainingOfTheDays,
        isAllResultSet: isAllResultSet,
        updateCollapsed: updateCollapsed,
        seeResultsForTraining: seeResultsForTraining,
        openDate: openDate,
        isMeasureTime: isMeasureTime,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        openDatePicker() {
            const input = this.$refs.dateInput;
            if (input) {
                if(this.isMobile()){
                    input.click();
                    console.log(input);
                }else{
                    input.showPicker();
                    console.log(input);
                }
            }
        }
    },

    created() {

        this.$topnavbar.$on('closeTrainingDefinition', () => {
            this.addDefinitionDate = ''
            this.showAddDefinition = false
        });

        this.$topnavbar.$on('successTrainingDefinition', () => {
            this.addDefinitionDate = ''
            this.showAddDefinition = false
            this.getTrainingOfTheDayForPeriod();
        });

        this.$topnavbar.$on('chooseExistTraining', (data) => {
            this.addDefinitionDate = ''
            this.showAddDefinition = false
            this.showChooseDefinition = true
            this.chooseDefinitionDate = data
        });

        this.$topnavbar.$on('closeChooseDefinition', () => {
            this.showChooseDefinition = false
            this.chooseDefinitionDate = ''
        });

        this.$topnavbar.$on('onTrainingDefinitionSelected', (data) => {
            this.showChooseDefinition = false
            this.chooseDefinitionDate = ''
            this.getTrainingOfTheDayForPeriod();
        });





    },

    beforeMount() {
        // if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
        //     this.$router.push(CONFIG_COMPANY.HOME);
        //     return;
        // }
        this.showWodResults = CONFIG_COMPANY.SHOW_WOD_RESULTS != null ? CONFIG_COMPANY.SHOW_WOD_RESULTS : false;
        this.role = session.getRole();
        this.getMe();

    },

    watch: {
        'selectedDate': function (newVal) {
            if (this.membershipExpired) return;
            if(newVal != null){
                this.currentWeek = this.$moment(new Date(newVal)).format('DD-MM-YYYY');
                this.currentDate = new Date(newVal);
                this.displayWeek();
            }
        }
    },
}

function getMe() {
    let _self = this;
    if(localStorage.getItem('ACCESS_TOKEN') == null){
        if(session.getWodLastDate() != null){
            this.selectedDate = session.getWodLastDate()
        }else{
            this.displayWeek();
        }
        return;
    }

    AdminApiService.getProfile()
        .then((response) => {
            this.role = response.data.role;
            const expireTimestamp = response && response.data ? response.data.expireDate : null;
            if(expireTimestamp == null){
                _self.membershipExpired = false;
            }else{
                const expireDate = _self.$moment(new Date(expireTimestamp * 1000)).startOf('day');
                const today = _self.$moment(new Date()).startOf('day');
                _self.membershipExpired = expireDate.isBefore(today);
            }

            if(_self.membershipExpired){
                _self.isLoading = false;
                _self.week = [];
                return;
            }

            if(session.getWodLastDate() != null){
                _self.selectedDate = session.getWodLastDate()
            }else{
                _self.displayWeek();
            }
        })
        .catch(() => {
            if(this.$route.query.programToken != null){
                _self.handleProgramDisplayError();
                return;
            }
            _self.membershipExpired = false;
            if(session.getWodLastDate() != null){
                _self.selectedDate = session.getWodLastDate()
            }else{
                _self.displayWeek();
            }
        })
}


function openDate(){
    this.$refs.dateInput.focus(); // Fokusiraj input pre nego što ga klikneš
    setTimeout(() => {
        this.$refs.dateInput.click();
    }, 100); // Mali delay pomaže u nekim pretraživačima
}

function isMeasureTime(measure){
    return measure === 'min' || 'measure' === 'Min'
}

function showDefinitionAdd(item){
    this.definitionDataToEdit = null
    this.addDefinitionDate = item.date
    this.showAddDefinition = true
}

function editDefinitionData(item){
    this.definitionDataToEdit = item
    this.addDefinitionDate = item.date
    this.showAddDefinition = true
}

function getStartOfWeek(date) {
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Adjust when day is Sunday
    return new Date(date.setDate(diff));
}

// Funkcija za formatiranje datuma
function formatDate(date) {
    return this.$moment(date).format('DD-MM-YYYY')
    // return date.toLocaleDateString('en-GB', {
    //     day: '2-digit',
    //     month: '2-digit',
    //     year: 'numeric'
    // });
}


// Funkcija za prikaz trenutne nedelje u kontejnerima
function displayWeek() {
    const startOfWeek = this.currentDate;//getStartOfWeek(new Date(this.currentDate));
    this.week = [];
    for (let i = 0; i < 1; i++) {
        const currentDay = new Date(startOfWeek);
        currentDay.setDate(startOfWeek.getDate() + i);
        this.week.push({
            date: this.formatDate(currentDay),
            details: []
        })
        // weekContainer.children[i].textContent = formatDate(currentDay);
    }

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 1);
    this.startDate = this.formatDate(startOfWeek);
    this.endDate = this.formatDate(startOfWeek);
    this.currentWeek = ` ${this.startDate}`;
    this.getTrainingOfTheDayForPeriod();
}

// Funkcija za promenu nedelje
function changeWeek(offset) {
    this.week = [];
    this.currentDate.setDate(this.currentDate.getDate() + offset);
    this.selectedDate = this.$moment(new Date(this.currentDate)).format('YYYY-MM-DD')
    session.saveWodLastDate(this.selectedDate)
}

function getTrainingOfTheDayForPeriod(){
    let _self = this;
    let model = {
        fromDate: this.startDate,
        toDate: this.endDate,
        type: "WOD"
    }
    _self.isLoading = true;
    AdminApiService.getUserTrainingOfTheDayForPeriod(model)
        .then((response) => {
            this.week.forEach(w => {w.details = [];})
            response.data.forEach(dateObj => {

                dateObj.collapsed = true;
                dateObj.results = [];
                if(dateObj.resultRounds != null && dateObj.resultRounds > 0){
                    for (var i = 0; i < dateObj.resultRounds; i++){
                        dateObj.results.push({
                            index: (i + 1),
                            id: null,
                            quantity: 1,
                            weight: null,
                            min: null,
                            sec: null
                        })
                    }
                }
                dateObj.isLoadingResults = dateObj.resultRounds != null || dateObj.resultMeasure;

                const item = this.week.find(entry => entry.date === dateObj.date);
                if (item) {
                    item.details.push(dateObj);
                }
            });
            _self.isLoading = false;
            _self.getTrainingResultsForTrainingOfTheDays(response.data)
        })
        .catch(error => {
            _self.handleProgramDisplayError();
        })
}

function handleProgramDisplayError(){
    this.isLoading = false;
    this.hasProgramError = true;
    this.week = [];
    this.programErrorMessage = LocService.t('label_wod_program_display_error');
}


function getName(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.name;
    }else if(item.enName != null && item.enName.length > 0){
        return  item.enName;
    }
    return item.name;
}

function getShortDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.shortDescription;
    }else if(item.enShortDescription != null && item.enShortDescription.length > 0){
        return  item.enShortDescription;
    }
    return item.shortDescription;
}

function getLongDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.longDescription;
    }else if(item.enLongDescription != null && item.enLongDescription.length > 0){
        return  item.enLongDescription;
    }
    return item.longDescription;
}

function deleteTrainingOfTheDay(item){
    let _self = this;
    swal({
        title: LocService.t("label_delete_training_of_the_day"),
        text: LocService.t("label_delete_training_of_the_day_are_you_sure") + ": " + this.getName(item),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteTrainingOfTheDay(item.id)
            .then((response) => {
                swal(LocService.t("label_success"), LocService.t('label_delete_training_of_the_day_successfully'), 'success')
                _self.getTrainingOfTheDayForPeriod();
            })
            .catch(error => {
                _self.handleProgramDisplayError();
            })

    })
}

function getPlaceholderTypeByMeasure(measure){
    if(this.isMeasureTime(measure)){
        return "MM,SS"
    }
    return measure;
}

function getDayFromDate(dateString){
    const [day, month, year] = dateString.split("-");
    const date = new Date(year, month - 1, day);

// Dobij dan u sedmici (0 je nedelja, 1 je ponedeljak, itd.)
    const dayOfWeek = date.getDay();

    switch (dayOfWeek) {
        case 1:
            return LocService.t('day_monday')
        case 2:
            return LocService.t('day_tuesday')
        case 3:
            return LocService.t('day_wednesday')
        case 4:
            return LocService.t('day_thursday')
        case 5:
            return LocService.t('day_friday')
        case 6:
            return LocService.t('day_saturday')
        case 0:
            return LocService.t('day_sunday')
    }
}

function getTrainingResultsForTrainingOfTheDays(allItems){
    let _self = this;
    const ids = allItems.map(o => o.id);
    if(ids == null || ids.length <= 0) return;
    AdminApiService.getTrainingResultsForTrainingOfTheDays(ids)
        .then((response) => {
            //set loading false for results
            _self.week.forEach(w => {w.details.forEach(d => {
                d.isLoadingResults = false;
                let results = response.data[d.id]
                if(results != null){
                    d.collapsed = true;
                    d.results = []
                    var round = 1;
                    results.forEach( result => {
                        var min = null;
                        var sec = null;
                        if(_self.isMeasureTime(result.measure)){
                            const formattedNumber = result.weight.toFixed(2);
                            const [integerPart, decimalPart] = formattedNumber.split(".");
                            min = integerPart;
                            sec = decimalPart;
                        }
                        d.results.push({
                            index: round,
                            id: result.id,
                            quantity: result.quantity,
                            weight: result.weight,
                            min: min,
                            sec: sec,
                        })
                        round++;
                    })
                }
            })})
            //TODO dodaj logiku da se popune rezultati ako postoje

        })
        .catch(error => {
            _self.handleProgramDisplayError();
        })
}

function saveResults(detailsItem){
    let _self = this;
    var model = {
        data: []
    }
    var roundIndex = 1;
    detailsItem.results.forEach(i => {
        var finalWeight = i.weight;
        if(_self.isMeasureTime(detailsItem.resultMeasure)){
            finalWeight = Number(`${i.min}.${i.sec}`)
        }
        let modelItem = {
            id: i.id,
            type: "WOD",
            measure: detailsItem.resultMeasure,
            quantity: i.quantity,
            weight: finalWeight,
            round: roundIndex,
            trainingOfTheDayId: detailsItem.id
        }
        model.data.push(modelItem)
        roundIndex++;
    });
    detailsItem.isLoadingResults = true;
    AdminApiService.saveTrainingResultsForTrainingOfTheDays(model)
        .then((response) => {
            detailsItem.isLoadingResults = false;
            detailsItem.collapsed = true;
            var items = [];
            this.week.forEach(w => {
                w.details.forEach(detailItem => {
                    items.push({id: detailItem.id})
                })
            })
            _self.getTrainingResultsForTrainingOfTheDays(items)
        })
        .catch(error => {
            detailsItem.isLoadingResults = false;
            _self.handleProgramDisplayError();
        })

}

function isAllResultSet(detailsItem){
    var isEnable = true;
    if(this.isMeasureTime(detailsItem.resultMeasure)){
        detailsItem.results.forEach(i => {
            if(i.quantity == null || i.quantity.length === 0
                || i.min == null || i.min.length === 0
                || i.sec == null || i.sec.length === 0) {
                isEnable = false;
            }
        });
    }else{
        detailsItem.results.forEach(i => {
            if(i.quantity == null || i.quantity.length === 0
                || i.weight == null || i.weight.length === 0) {
                isEnable = false;
            }
        });
    }

    return isEnable;
}

function updateCollapsed(detailsItem){
    if(detailsItem.collapsed === true){
        detailsItem.collapsed = false
    }else{
        detailsItem.collapsed = true
    }
}

function seeResultsForTraining(detailsItem){
    this.$router.push('/wod-user-results?id=' + detailsItem.id + '&date=' + this.currentWeek.trim() + '&name='+this.getName(detailsItem) + '&programToken=' + session.getAccessToken())
}



// WEBPACK FOOTER //
// ./src/components/Wod/WodProgram.js